import { useField } from "formik";

import useDependentField, {
  usePropertyExtractor,
} from "../../hooks/use-dependent-field";
import { classnames } from "../../utils/index.jsx";
import TextInputStandalone from "./TextInputStandalone";

export default function TextInput({
  className,
  marginForm = "margin-form",
  dependon,
  ...props
}) {
  const [field, meta] = useField(props);

  useDependentField(props.name, dependon, usePropertyExtractor(props.name));
  return (
    <TextInputStandalone
      className={classnames(className, marginForm)}
      error={meta.touched && meta.error}
      {...field}
      {...props}
    />
  );
}
